import React from "react";
import { DollarSign, Eye, TriangleAlert } from "lucide-react";
import { Badge } from "antd";
import { actions } from "./actions";


const OverdueCard = ({ data }) => {
    const overdueData = data ?? actions.filter(a => a.category === "Overdue - Urgent");
    if (overdueData.length === 0) return null;  
    
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2">
        <TriangleAlert className="w-3.5 h-3.5 text-red-600 dark:text-red-400" />
        <h3 className="text-[12px] text-red-600 dark:text-red-300">
          Overdue - Urgent
        </h3>
        <Badge
          count={overdueData.length}
          size="small"
          style={{
            backgroundColor: "rgb(251 44 54)",
            color: "#ffffff",
            border: "none",
            fontSize: "9px",
          }}
        />
      </div>

      {overdueData.map((item, idx) => (
        <div
          key={idx}
          className="card-border-s red-white rounded-xl"
        >
          <div className="items-start gap-1.5 pb-2 pt-3 px-3">
            <div className="flex items-start justify-between gap-2">
              {overdueData &&
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                  <h4 className="text-[13px] title-text">{item.title}</h4>
                  <Badge
                    count={`${item.overdueCount}d overdue`}
                    style={{
                      backgroundColor: "rgb(251 44 54)",
                      color: "#fff",
                      fontSize: "9px",
                      height: "16px",
                      minWidth: "auto",
                    }}
                  />
                </div>
                <p className="text-[11px] line-clamp-1 muted-text">{item.description}</p>
              </div>
              }

              <div className="text-right shrink-0">
                <div className="text-[15px] font-semibold text-red-600 dark:text-red-100">
                  ${item.amountDue.toFixed(2)}
                </div>
                <p className="text-[9px] muted-text">Due: {item.dueDate}</p>
              </div>
            </div>
          </div>

          <div className="pb-6 px-3 pb-2 mt-6">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-1 flex-wrap">
                <p className="status-indicator normal text-[8px] bg-slate-50">{item.department}</p>
                <p className="status-indicator normal text-[8px] bg-slate-50">{item.invoiceNumber}</p>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <button className="status-indicator font-medium transition-al rounded-lg h-6 text-[10px] px-2 bg-white text-foreground">
                  <Eye className="w-3 h-3" />
                </button>
                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-lg gap-1.5 h-6 text-[10px] px-2 bg-red-600 hover:bg-red-700 text-white">
                  <DollarSign className="w-3 h-3 mr-1" />
                  Pay
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverdueCard;
